import { render, staticRenderFns } from "./StudioPicker.vue?vue&type=template&id=023a2285&scoped=true"
import script from "./StudioPicker.vue?vue&type=script&lang=js"
export * from "./StudioPicker.vue?vue&type=script&lang=js"
import style0 from "./StudioPicker.vue?vue&type=style&index=0&id=023a2285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023a2285",
  null
  
)

export default component.exports